import { getOjSocket } from '@/plugin/socket'

class OnlineJudgePython {
  socketReady = false

  constructor (ctx, shell) {
    this.$api = ctx.$api
    this.$noty = ctx.$noty
    this.shell = shell
  }

  async ensureSocket (onResult) {
    this.socketReady = false
    let socket = await getOjSocket()
    return new Promise((resolve, reject) => {
      const joinRoom = (socket) => {
        socket.emit('users.join_room', 'room_oj_service')
        socket.off('oj.status')
        socket.off('oj.result')
        socket.on('oj.status', (data) => {
          // data = Utils.ojQueueProcess(data)
          this.$noty.info('请稍候, 有 ' + data + ' 段代码正在运行')
        })
        socket.on('oj.result', (data) => {
          onResult(data)
        })
        this.socketReady = true
        return socket
      }
      if (socket.connected) return resolve(joinRoom(socket))

      let counter = 0
      const checkSocket = async () => {
        counter > 3 && this.$noty.warning('检测到与服务器连接中断, 正在尝试重新连接, 重试次数: ' + (counter + 1))
        socket = await getOjSocket()
        counter += 1
        if (counter > 5) {
          this.$noty.warning('无法连接到服务器，如果刷新页面后仍然不能连接，请退出网站并重新登录')
          reject(new Error('网络连接失败, 请检查网络连接'))
          return
        }
        if (socket.connected) {
          return resolve(joinRoom(socket))
        } else {
          setTimeout(checkSocket, 1000)
        }
      }

      checkSocket()
    })
  }

  async run (code, shell, attachments = []) {
    if (shell) {
      this.shell = shell
    } else {
      shell = this.shell
    }
    if (!shell) return
    if (!code) {
      shell.output = '没有可以运行的代码'
      return
    }
    shell.status = 'running'
    await this.ensureSocket((data) => {
      shell.output = data.result.result || '无输出'
      shell.status = 'stop'
    })
    try {
      shell.output = '服务器正在努力运行，Good Luck ~'
      this.$api.post('/playground/result', {
        code: code,
        language: 'python',
        input: shell.input || '',
        attachments: attachments,
        version: '2'
      }, {}, false)
    } catch (e) {
      shell.output = '代码未成功运行, 请重试\n' + e.message
    }
  }

  async runProblemTestcases (app, url, problem, onResult) {
    let onResultCount = problem.testcases.length
    try {
      await this.ensureSocket((data) => {
        const testcase = problem.testcases.find(p => p._id === data.testcaseId)
        if (testcase) {
          app.$set(testcase, 'status', data.result.status)
          if (testcase.type === 'static') {
            app.$set(testcase, 'result', data.result.result)
            if (data.result.status !== 200) {
              this.$noty.warning('代码静态检查未通过' + data.result.result)
              for (let testcase of problem.testcases) {
                app.$set(testcase, 'running', false)
              }
            }
          }
          if (testcase.type === 'style') {
            data.result.result = data.result.result.replace('Your code has been rated at', '代码风格得分')
            app.$set(testcase, 'result', data.result.result)
            app.$set(testcase, 'static_score', data.result.staticScore)
          }

          testcase.show && app.$set(testcase, 'result', data.result.result)
          app.$set(testcase, 'exec_time', data.result.realTime)

          // 已运行用例技术
          if (onResult) {
            onResultCount -= 1
            if (onResultCount === 0) {
              onResult()
            }
          }
        }
      })

      this.$noty.info('代码已上传，服务器正在努力运行程序, 请稍候')

      problem.testcases.forEach(testcase => {
        app.$set(testcase, 'running', true)
        app.$delete(testcase, 'result')
        app.$delete(testcase, 'status')
      })

      if (problem.auto_judge) {
        await this.$api.get(`${url}/testcases/result`, {}, {}, false)
      }
    } catch (e) {
      console.log(e)
      this.$noty.warning('测试用例未成功运行,请重试')
    }
  }
}

export default OnlineJudgePython
